import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

const ProjectWizardEditModeContext = createContext({
  isEditMode: false,
});

export const ProjectWizardEditModeProvider = ({ isEditMode, children }) => (
  <ProjectWizardEditModeContext.Provider value={{ isEditMode }}>
    {children}
  </ProjectWizardEditModeContext.Provider>
);

ProjectWizardEditModeProvider.propTypes = {
  isEditMode: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export const useProjectWizardEditMode = () => {
  const { isEditMode } = useContext(ProjectWizardEditModeContext);
  return {
    isEditMode,
    isReadOnly: !isEditMode,
  };
};

export default ProjectWizardEditModeContext;
